import { render, staticRenderFns } from "./myfooter.vue?vue&type=template&id=77d0fab5&scoped=true&"
import script from "./myfooter.vue?vue&type=script&lang=js&"
export * from "./myfooter.vue?vue&type=script&lang=js&"
import style0 from "./myfooter.vue?vue&type=style&index=0&id=77d0fab5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d0fab5",
  null
  
)

export default component.exports